import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSearchService } from './app-search.service';

@Injectable()
export class AppSearchFacade implements OnDestroy {
  private readonly showSearch = new BehaviorSubject<boolean>(false);
  private readonly searchText = new BehaviorSubject<string>('');

  showSearch$ = this.showSearch.asObservable();
  searchText$ = this.searchText.asObservable();

  constructor(private readonly appSearchService: AppSearchService) {}

  ngOnDestroy() {}

  getCalendarTripSearch(searchText: string, startDateTime: string, endDateTime: string) {
    return this.appSearchService.getCalendarTripSearch(searchText, startDateTime, endDateTime).pipe(
      map(res => res)
    );
  }

  getFullTextTripSearch(searchText: string, startDateTime: string, endDateTime: string) {
    return this.appSearchService.getFullTextTripSearch(
      searchText,
      startDateTime,
      endDateTime
    ).pipe(
      map(res => res)
    );
  }
}
